import EFPic from '@/components/UI/EFPic';
import EFCSR from '@/components/UI/svg/CSR/Icons/EFCSR';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax, TimelineMax } from 'gsap';

export default function A() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('csr');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        new ScrollMagic.Scene({
            triggerElement: '.csr_pc_A', // 动画触发元素
            triggerHook: 1, // 1: 元素进入视图  0: 元素离开试图 （范围：0-1）
            offset: layoutH - 60, // header的60高度
            // duration: 0  // 动画持续距离（当前触发性css动画多，不需要该属性； 跟随鼠标滚动事件动画则需要）
        })
            .setClassToggle('.csr_pc_A', 'enter')
            .addTo(controller);

        // 视差偏移
        new ScrollMagic.Scene({
            triggerElement: '.csr_pc_A', // 动画触发元素
            triggerHook: 1, // 1: 元素进入视图  0: 元素离开试图 （范围：0-1）
            offset: layoutH - 60, // header的60高度
            duration: layoutH,
        })
            .setTween(
                new TimelineMax().add([
                    TweenMax.to('.csr_pc_A .CSR-A-img-box', 1, {
                        transform: 'translateY(-50px)',
                    }),
                    TweenMax.to('.csr_pc_A .CSR-A-desc-box', 1, {
                        transform: 'translateY(-65px)',
                    }),
                ]),
            )
            .addTo(controller);
    }, []);

    const letters: [string] = t('secA_title')?.split('');

    return (
        <div className={`csr_pc_A ${css.csr_pc_A}`}>
            <EFPic className="CSR-A-bgimg" src={['/img/csr/pc/1.webp', '/img/csr/pc/1.jpg']} alt={t('secA_title')} aria-label={t('secA_title')} />
            <div className="csr-A-content">
                <div className="CSR-A-guide">{t('secA_guide')}</div>
                <div className="CSR-A-title">
                    {letters.map((letter: string, index: number) => (
                        <span
                            key={index}
                            style={{
                                transition: `all 1s cubic-bezier(0.2, 0, 0.32, 1) ${index * 67}ms`,
                                fontSize: '72px',
                                transform: `translateY(100px)`,
                                opacity: 0,
                            }}
                        >
                            {letter}
                        </span>
                    ))}
                </div>
                <div className="CSR-A-svg">
                    <div className="svgInner">
                        <EFCSR />
                    </div>
                </div>
                <div className="CSR-A-img-box">
                    <EFPic className="CSR-A-img" src={['/img/csr/pc/a-1.webp', '/img/csr/pc/a-1.png']} />
                </div>
                <div className="CSR-A-desc-box">
                    <p className="CSR-A-desc">{t('secA_text')}</p>
                </div>
            </div>
        </div>
    );
}
